import { DabltModel } from "app/model/mng/Dablt";
import Api from "../common/Api";
import { ApiUrlUtil } from "app/utils/apiUrlUtil";

export class DabltMngService extends Api {
  private static service: DabltMngService;

  public static getInstance(): DabltMngService {
    if (!DabltMngService.service) {
      DabltMngService.service = new DabltMngService();
    }
    return DabltMngService.service;
  }

  public async save(model: DabltModel) {
    return await super.post<DabltModel>(process.env.REACT_APP_URL_WP + '/dabltMng', model);
  }

  public async findById(id: any) {
    return await super.get<any>(process.env.REACT_APP_URL_WP + '/dabltMng/' + id);
  }

  public async deleteDablt(id: string) {
    return await super.delete<DabltModel>(process.env.REACT_APP_URL_WP + '/dabltMng/' + id);
  }

  public async pieChartData(search: any) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_WP + '/dabltMng/pieChartData');
    return await super.get<any>(url, search);
  }

  public async getStatisticData() {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_WP + '/dabltMng/getStatisticData');
    return await super.get<any>(url);
  }
}
